import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import { StyledDropdownLabelGapWrapped } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalsDropdownLabel/styles";
import { StyledInlineFilterWrapper } from "app/pages/sales-intelligence/sub-modules/signals/components/styles";
import type { TechnologySignalFilterViewProps } from "app/pages/sales-intelligence/sub-modules/signals/components/views/TechnologySignalFiltersView/models/TechnologySignalFilterViewProps";
import TechnologySignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalSubType";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

const ADDING_SUB_TYPES: readonly TechnologySignalSubType[] = [
    TechnologySignalSubType.AddedTechnologies,
    TechnologySignalSubType.AddedIntegrations,
];

/**
 * A fragment, not an element: its pieces flow inline alongside the timeframe the parent appends, so
 * the card reads as one wrapping sentence rather than stacked blocks.
 */
const TechnologySignalDefaultFiltersView = ({
    children,
    signalSubType,
}: TechnologySignalFilterViewProps): ReactElement => {
    const leadIn =
        signalSubType && ADDING_SUB_TYPES.includes(signalSubType)
            ? signalsI18nKeys.managementSentence.technology.installed
            : signalsI18nKeys.managementSentence.technology.removed;

    return (
        <>
            <StyledDropdownLabelGapWrapped data-automation="technology-filter-text">
                {translate(leadIn)}
            </StyledDropdownLabelGapWrapped>
            <StyledInlineFilterWrapper>{children}</StyledInlineFilterWrapper>
        </>
    );
};

export default TechnologySignalDefaultFiltersView;
